const VERSION = 1;

export { VERSION };
